import Skelet from '../Skelet';
import styles from '../../styles/modules/building/BuildingObjectsList.module.scss';

const BuildingObjectsList = () => {
  return (
    <div className={styles.list}>
      {[...Array(10).keys()].map((value) => (
        <div
          className={styles.listItem}
          style={{ display: 'flex', alignItems: 'center' }}
          key={value}
        >
          <Skelet
            width={60}
            height={60}
            className={styles.listItemTitle}
            style={{ borderRadius: 10, margin: 4 }}
          />
          <Skelet width="10%" height={20} className={styles.listItemText} />
          <Skelet width="10%" height={20} className={styles.listItemText} />
          <Skelet width="10%" height={20} className={styles.listItemText} />
          <Skelet width="10%" height={20} className={styles.listItemText} />
        </div>
      ))}
    </div>
  );
};

export default BuildingObjectsList;
